// core
import { useEffect } from 'react'
// libraries
import { useFormikContext } from 'formik'
// partial
import { IVenueFormValues } from './FormPage'
// utils
import { IRoom, local } from 'utils'

const removeFilesFromForm = (rooms: IRoom[]) => {
  return rooms.map((room) => {
    const copiedRoom = { ...room }

    //@ts-ignore
    delete copiedRoom.thumbnail
    delete copiedRoom.photos

    return copiedRoom
  })
}

export const OnChange = () => {
  const { values } = useFormikContext<IVenueFormValues>()

  useEffect(() => {
    const copiedValues = { ...values }

    // to not save whole file object into local storage
    //@ts-ignore
    delete copiedValues.thumbnail
    //@ts-ignore
    delete copiedValues.photos

    local.setItem(
      'values',
      JSON.stringify({
        ...copiedValues,
        rooms: removeFilesFromForm((copiedValues.rooms as IRoom[]) || []),
        meetingRooms: values.additionalInfo?.hasMeetingRooms
          ? removeFilesFromForm((copiedValues.meetingRooms as IRoom[]) || [])
          : undefined,
      })
    )
  }, [values])

  return null
}
